import { ICalendarHolidayData, ITimeOffCalendarData } from '@/models';
import {
  ICalendarTimeOffHolidaysData,
  ITimeOffCalendarState
} from '@/store/timeoff-calendar';

import { ITimeOffCalendarMutations } from './mutations.types';

export const mutations: ITimeOffCalendarMutations = {
  SET_CALENDAR_YEARS(
    state: ITimeOffCalendarState,
    payload: ITimeOffCalendarData[]
  ): void {
    state.calendars = payload;
  },

  ADD_CALENDAR_YEAR(
    state: ITimeOffCalendarState,
    payload: ITimeOffCalendarData
  ): void {
    state.calendars.push(payload);
  },

  UPDATE_CALENDAR_YEAR(
    state: ITimeOffCalendarState,
    payload: ITimeOffCalendarData
  ): void {
    const index = state.calendars.findIndex(
      (calendar: ITimeOffCalendarData) => calendar.id === payload.id
    );

    state.calendars.splice(index, 1, payload);
  },

  REMOVE_CALENDAR_YEAR(state: ITimeOffCalendarState, payload: number): void {
    const index = state.calendars.findIndex(
      (calendar: ITimeOffCalendarData) => calendar.id === payload
    );

    state.calendars.splice(index, 1);
  },

  //holidays
  SET_CALENDAR_HOLIDAYS(
    state: ITimeOffCalendarState,
    payload: ICalendarTimeOffHolidaysData
  ): void {
    const index = state.calendarHolidays.findIndex(
      (calendarHoliday: ICalendarTimeOffHolidaysData) =>
        calendarHoliday.calendar === payload.calendar
    );

    if (index == -1) {
      state.calendarHolidays.push(payload);
    } else {
      state.calendarHolidays.splice(index, 1, payload);
    }
  },

  ADD_CALENDAR_HOLIDAY(
    state: ITimeOffCalendarState,
    payload: ICalendarTimeOffHolidaysData
  ): void {
    const index = state.calendarHolidays.findIndex(
      (calendarHoliday: ICalendarTimeOffHolidaysData) =>
        calendarHoliday.calendar === payload.calendar
    );

    if (index == -1) return;

    (state.calendarHolidays[index].holidays as ICalendarHolidayData[]).push(
      payload.holidays as ICalendarHolidayData
    );
  },

  UPDATE_CALENDAR_HOLIDAY(
    state: ITimeOffCalendarState,
    payload: ICalendarTimeOffHolidaysData
  ): void {
    const index = state.calendarHolidays.findIndex(
      (calendarHoliday: ICalendarTimeOffHolidaysData) =>
        calendarHoliday.calendar === payload.calendar
    );

    if (index == -1) return;

    const holidayIndex = (state.calendarHolidays[index]
      .holidays as ICalendarHolidayData[]).findIndex(
      (holiday: ICalendarHolidayData) =>
        holiday.id === (payload.holidays as ICalendarHolidayData).id
    );

    if (holidayIndex == -1) return;

    (state.calendarHolidays[index].holidays as ICalendarHolidayData[]).splice(
      holidayIndex,
      1,
      payload.holidays as ICalendarHolidayData
    );
  },

  REMOVE_CALENDAR_HOLIDAY(
    state: ITimeOffCalendarState,
    payload: ICalendarTimeOffHolidaysData
  ): void {
    const index = state.calendarHolidays.findIndex(
      (calendarHoliday: ICalendarTimeOffHolidaysData) =>
        calendarHoliday.calendar === payload.calendar
    );

    if (index == -1) return;

    const holidayIndex = (state.calendarHolidays[index]
      .holidays as ICalendarHolidayData[]).findIndex(
      (holiday: ICalendarHolidayData) =>
        holiday.id === (payload.holidays as ICalendarHolidayData).id
    );

    if (holidayIndex == -1) return;

    (state.calendarHolidays[index].holidays as ICalendarHolidayData[]).splice(
      holidayIndex,
      1
    );
  }
};
